import RestPlusCopy from "../../../../../Atoms/RestPlusCopy";

export const SUB_NAVIGATION_ITEMS = [
  {
    title: "Adults",
    handle: "adults",
    menu: [
      {
        title: "Restore",
        handle: "restore",
        url: "/restore",
        info: {
          description:
            "A sound machine, sunrise alarm, smart light, meditation app, and an alarm clock, all in one smart sleep assistant.",
          imageBadges: [
            {
              title: "Top Rated",
              backgroundColor: "",
            },
            // {
            //   title: '$15 off',
            //   backgroundColor: 'lightNavy'
            // },
          ],
          image: {
            src: "Nav-Desktop-Restore.jpg",
            alt: "Picture of Restore Product Lit up on a Table",
          },
        },
      },
    ],
  },
  {
    title: "Babies & Kids",
    handle: "babiesKids",
    menu: [
      {
        title: "Rest",
        url: "/rest",
        info: {
          description:
            "A magical all-in-one device that's part sound machine, part night light and 100% a dream for parents.",
          imageBadges: [
            {
              title: "Best Seller",
              backgroundColor: "",
            },
          ],
          image: {
            src: "Nav-Desktop-Rest.jpg",
            alt: "Picture of Rest Product Lit up on a table",
          },
        },
      },
      {
        title: <RestPlusCopy />,
        url: "/rest-plus",
        info: {
          description:
            "The ultimate, magical all-in-one sleep machine for babies & kids — with a clock, voice control & more.",
          image: {
            src: "Nav-Desktop-RestPlus.jpg",
            alt: "Rest Plus product lit up and on the table",
          },
        },
      },
      {
        title: "Rest Mini",
        url: "/rest-mini",
        info: {
          description: "A sound machine for big dreams, with a tiny footprint",
          image: {
            src: "Nav-Desktop-RestMini.jpg",
            alt: "picture of Rest mini product on a table next to a pillow",
          },
        },
      },
      {
        title: "Shop all Rest products",
        url: "/rest-family",
        info: {
          description: "A sound machine for big dreams, with a tiny footprint",
          image: {
            src: "Nav-Desktop-RestMini.jpg",
            alt: "picture of Rest mini product on a table next to a pillow",
          },
        },
      },
    ],
  },
  {
    menu: [
      {
        title: "Accessories",
        url: "/shop-all#accessories-section",
        info: {
          description: "A sound machine for big dreams, with a tiny footprint",
          image: {
            src: "Nav-Desktop-RestMini.jpg",
            alt: "picture of Rest mini product on a table next to a pillow",
          },
        },
      },
      {
        title: "Blog",
        url: "/blog",
        info: {
          description: "A sound machine for big dreams, with a tiny footprint",
          image: {
            src: "Nav-Desktop-RestMini.jpg",
            alt: "picture of Rest mini product on a table next to a pillow",
          },
        },
      },
      {
        title: "Shop all products",
        url: "/shop-all",
        info: {
          description: "A sound machine for big dreams, with a tiny footprint",
          image: {
            src: "Nav-Desktop-RestMini.jpg",
            alt: "picture of Rest mini product on a table next to a pillow",
          },
        },
      },
    ],
  },
];
